export default "__VITE_ASSET__bf9655a5__"